import { object, string } from 'yup';

export function emailValid(email) {
  const emailSchema = object({
    email: string().email().required(),
  });

  return emailSchema.isValidSync({ email });
}
